var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEmoticon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.001,
    height: 20.001,
    viewBox: "0 0 20.001 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon emoticon"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 .001)",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.898 -101.501)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    "data-name": "\\uD328\\uC2A4 1198",
    d: "M30.9 121.5h-12a4 4 0 0 1-4-4v-12a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4zm-12-18a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "current",
    "data-name": "\\uD0C0\\uC6D0 418",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(20.898 107.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "current",
    "data-name": "\\uD0C0\\uC6D0 419",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(26.898 107.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    "data-name": "\\uD328\\uC2A4 1199",
    d: "M24.9 117.5c-3.308 0-6-2.236-6-4.984a1 1 0 0 1 .4-.8c.29-.22.291-.218 5.609-.218 5.3 0 5.3 0 5.576.2a1 1 0 0 1 .42.815c-.005 2.752-2.697 4.987-6.005 4.987zm-3.774-4a4.105 4.105 0 0 0 3.774 2 4.108 4.108 0 0 0 3.774-1.994c-1.918-.006-5.646-.006-7.549 0z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmoticon);
export default __webpack_public_path__ + "static/media/icon-emoticon.360d3b12f6ad0dea654facdc65652c59.svg";
export { ForwardRef as ReactComponent };